// ─────────────────────────────────────────────────────────────────────────────
// MILESTONE: this component is the first feature built ENTIRELY by the AI code-
// building harness (backlog/ plan-queue) — planned, implemented by a headless
// Claude on its own branch, gated by an automated test, and auto-merged into the
// active branch with no manual coding or merge step. See backlog/README.md.
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';

export default function RoleBadge({ isAdmin, isLoggedIn, loginRequired }) {
  if (loginRequired && !isLoggedIn) return null;
  return (
    <span className={`demo-nav-role ${isAdmin ? 'admin' : 'guest'}`}>
      {isAdmin ? 'ADMIN' : 'GUEST'}
    </span>
  );
}
